<template>
  <div class="container">
    <div class="titulo text-center">
      <h2><strong>Configuración del Correo (SMTP)</strong></h2>
    </div>

    <div class="table-container">
      <table class="table table-striped table-hover table-bordered">
        <thead>
          <tr>
            <th>Nombre del Parámetro</th>
            <th>Valor</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="parametro in listaParametrosSMTP" :key="parametro.parametro_id">
            <!-- Nombre del Parámetro -->
            <td>{{ obtenerNombreAmigable(parametro.parametro_id) }}</td>

            <!-- Valor del Parámetro -->
            <td>
              <div v-if="parametro.editando">
                <!-- Modo edición -->
                <input
                  v-model="parametro.valor"
                  type="text"
                  class="form-control"
                />
              </div>
              <div v-else>
                <!-- Modo visualización -->
                {{ parametro.valor }}
              </div>
            </td>

            <!-- Acciones -->
            <td>
              <div v-if="parametro.editando">
                <!-- Botones para guardar o cancelar edición -->
                <button
                  @click="guardarParametro(parametro)"
                  class="btn btn-success btn-sm me-2"
                >
                  Guardar
                </button>
                <button
                  @click="cancelarEdicion(parametro)"
                  class="btn btn-secondary btn-sm"
                >
                  Cancelar
                </button>
              </div>
              <div v-else>
                <!-- Botón para habilitar edición -->
                <button
                  @click="editarParametro(parametro)"
                  class="btn btn-warning btn-sm"
                >
                  <i class="bi bi-pencil-square"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  data() {
    return {
      listaParametrosSMTP: [], // Lista de parámetros relacionados con SMTP
      nombresAmigables: {
        smtp_host: "Servidor SMTP",
        smtp_port: "Puerto SMTP",
        smtp_user: "Usuario SMTP",
        smtp_password: "Contraseña SMTP",
        smtp_secure: "Tipo de Seguridad (SSL/TLS)",
        smtp_name: "Nombre del Remitente",
      },

    };
  },
  methods: {
    // Obtener todos los parámetros SMTP
    getParametrosSMTP() {
      fetch(this.$backendUrl + "index.php/smtp/lista_completa", {
        method: "GET",
      })
        .then((response) => response.json())
        .then((data) => {
          // Agregar el flag `editando` a cada parámetro
          this.listaParametrosSMTP = data.map((parametro) => ({
            ...parametro,
            editando: false,
            valorOriginal: parametro.valor, // Para restaurar en caso de cancelar
          }));
        })
        .catch((error) => {
          Swal.fire("Error", "No se pudieron cargar los parámetros SMTP.", "error");
          console.error("Error al obtener los parámetros SMTP:", error);
        });
    },

    // Obtener el nombre amigable de un parámetro
    obtenerNombreAmigable(parametroId) {
      return this.nombresAmigables[parametroId] || parametroId;
    },

    // Habilitar modo edición
    editarParametro(parametro) {
      parametro.editando = true;
    },

    // Guardar cambios del parámetro
    guardarParametro(parametro) {
      if (!parametro.valor) {
        Swal.fire("Error", "El valor no puede estar vacío.", "error");
        return;
      }

      Swal.fire({
        title: "¿Estás seguro?",
        text: "Se actualizará el valor del parámetro SMTP.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, guardar",
      }).then((result) => {
        if (result.isConfirmed) {
          fetch(this.$backendUrl + "index.php/smtp/actualizar", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              parametro_id: parametro.parametro_id,
              valor: parametro.valor,
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              if (data.success) {
                Swal.fire("Éxito", "Parámetro SMTP actualizado correctamente.", "success");
                parametro.editando = false; // Salir del modo edición
              } else {
                Swal.fire("Error", data.message, "error");
              }
            })
            .catch((error) => {
              Swal.fire("Error", "No se pudo actualizar el parámetro SMTP.", "error");
              console.error("Error al actualizar el parámetro SMTP:", error);
            });
        }
      });
    },

    // Cancelar edición
    cancelarEdicion(parametro) {
      parametro.valor = parametro.valorOriginal; // Restaurar el valor original
      parametro.editando = false; // Salir del modo edición
    },
  },
  mounted() {
    // Cargar los parámetros SMTP al montar el componente
    this.getParametrosSMTP();
  },
};
</script>

<style scoped>
.titulo {
  background-color: #f52349;
  color: white;
  font-family: Arial, sans-serif;
  font-size: 18px;
  padding: 15px 10px;
  margin: 10px 0;
}

.table-container {
  overflow: auto;
  margin-top: 20px;
}

.btn-sm {
  font-size: 14px;
  padding: 5px 10px;
}

.me-2 {
  margin-right: 8px;
}
</style>
